import { createAction } from '@reduxjs/toolkit'
import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'
import { ECurrency } from 'types/Enums'

export type TSetGlobalFilter = {
  companyGroupId: string | null
  currency?: ECurrency | null
  customSelected: string[]
  variant: GlobalFilterVariant
}

// Initialize from localStorage
export const initialize = createAction<TSetGlobalFilter>(
  'initialize_global_filter'
)

// Update filter
export const update = createAction<TSetGlobalFilter>('update_global_filter')
